"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeNullishValues = void 0;
/**
 * Removes all null or empty string values from object recursively.
 * @returns object with null or empty string values removed
 * @param obj
 */
const removeNullishValues = (obj) => {
    Object.entries(obj).forEach(([key, val]) => (val && typeof val === 'object' && removeNullishValues(val)) ||
        ((val === null || val === '') && delete obj[key]));
    return obj;
};
exports.removeNullishValues = removeNullishValues;
//# sourceMappingURL=objects.js.map